export const LiveGames = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
        width={'100%'}
        height={'100%'}
    >
        <path
            className="ico_pri"
            d="m26.24 11.94-.345-1.29a3 3 0 0 0-3.675-2.12L9.538 11.926A2.992 2.992 0 0 0 7.42 15.59l5.57 20.78a3.007 3.007 0 0 0 3.68 2.12l.82-.22v-2.053l-1.347.36a1 1 0 0 1-1.225-.706l-5.57-20.787a1 1 0 0 1 .707-1.225l12.683-3.398a1 1 0 0 1 1.225.707l.206.772h2.071Z"
        />
        <path
            className="ico_pri"
            d="M12.85 21.12c.35.15.73.16 1.16.05.3-.08.56-.21.77-.4.21-.19.36-.44.44-.74.04-.14.05-.27.05-.39-.01-.12-.03-.25-.06-.38s-.07-.29-.12-.46l-1.01-3.77-.95.25 1.032 3.852c.032.119.062.228.078.318.02.11.03.22.02.31-.03.15-.09.27-.2.36-.1.09-.21.15-.32.18-.17.04-.33.03-.5-.05a.705.705 0 0 1-.36-.34l-.87.47c.22.35.5.59.84.74Z"
        />
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M22.48 15.95a1 1 0 0 0-1 1v21.52a1 1 0 0 0 1 1h13.13a1 1 0 0 0 1-1V16.95a1 1 0 0 0-1-1H22.48Zm-3 1a3 3 0 0 1 3-3h13.13a3 3 0 0 1 3 3v21.52a3 3 0 0 1-3 3H22.48a3 3 0 0 1-3-3V16.95Z"
            clipRule="evenodd"
        />
        <path
            className="ico_pri"
            d="M32.34 29.25c-.55-.42-2.2-1.71-2.98-2.73a.404.404 0 0 0-.64 0c-.79 1.04-2.49 2.36-3.01 2.75a2.376 2.376 0 0 0 .91 4.33c.68.11 1.32-.07 1.81-.43.08-.06.2 0 .18.11-.06.42-.23.93-.63 1.47-.12.16 0 .4.2.4h1.72c.21 0 .32-.23.2-.4-.4-.54-.57-1.05-.63-1.48-.01-.1.1-.17.19-.11.49.36 1.13.54 1.81.43.96-.15 1.75-.92 1.93-1.87.2-1.04-.27-1.98-1.06-2.48v.01Zm-10.29-5.39 1.83-5.79h1.42l1.83 5.79h-1l-1.66-5.2h.22l-1.64 5.2h-1Zm1.01-1.26v-.91h3.04v.91h-3.04Z"
        />
    </svg>
);
